<template>
  <div>
        <span :title="$t('GLOBAL_SWITCH_ENTITY')" class="entityTree" @click="drawer=true">
            <img :src="entity_icon" class="entity-icon">
        </span>
    <el-drawer
            class="drawer-wrapper"
            :title="$t('COMMON_ENTITY')"
            :modal="false"
            :append-to-body="false"
            :visible.sync="drawer"
            :direction="direction"
            size="440px"
            @opened="changeDrawer"
            :before-close="handleClose">
        <el-input :placeholder="$t('ENTER_SEARCH_CONTENT')" v-model="filterText" />
        <div style="overflow: auto;height: calc(100vh - 120px);">
          <el-tree
                  ref="entityTree"
                  :default-expand-all="true"
                  :expand-on-click-node="false"
                  :check-strictly="true"
                  :data="data"
                  class="treeWithEntity"
                  :props="defaultProps"
                  :filter-node-method="filterNode"
                  node-key="id"
                  show-checkbox
                  @check="handleCheckChange"
          >
               <div class="entity-list-tree-node" slot-scope="{ node, data }">
                   <span :title="node.label" @click="activeNode(data)">{{ node.label }}</span>
                   <span class="extra-area" v-if="data.childEntity.length > 0">
                       <a v-if="!isSelectAll(data)" @click="clickAll(data, true)">{{$t('select_all')}}</a>
                       <a v-else @click="clickAll(data, false)">{{$t('unselect_all')}}</a>
                   </span>
               </div>
          </el-tree>
        </div>
      
    </el-drawer>
  </div>
</template>
<script>
    import {mapGetters} from 'vuex'
    import { deepClone } from '@/utils'

    export default {
        data() {
            return {
                drawer: false,
                direction: 'rtl',
                defaultProps: {
                    children: 'childEntity',
                    label: 'entityName',
                },
                data: [],
                filterText: '',
                allIds: [],
                filterNodeList: [],
                entity_icon: require(`@/assets/img/icon-entity.svg`)
            };
        },
        methods: {
            updateDrawer() {
                this.drawer = true
            },
            // select all/unselect all
            clickAll(data, checked) {
                if(this.filterText.length > 0 ){
                    this.fileterClickAll(data, checked)
                } else {
                    if( !data.disabled ) {
                        this.$refs.entityTree.setChecked(data.id, checked, false);
                        data.checked = checked
                    }
                    if (data.childEntity.length > 0) {
                        data.childEntity.forEach(child => this.clickAll(child, checked));
                    }
                }
            },
            fileterClickAll(data, checked) {
                let temp = []
                if(data.entityType === 'ROOT') {
                    temp.push(data.id)
                    this.filterNodeList.forEach(item => {
                        temp.push(item.id)
                        temp.push(item.parentKey)
                    })
                    this.iteratorTree(data, checked, temp)
                } else {
                    // Entity
                    if(!data.disabled){
                        this.$refs.entityTree.setChecked(data.id, checked, false)
                        data.checked = checked
                    }
                    if(data.childEntity.length > 0) {
                        for(let i = 0 ; i < data.childEntity.length; i++){
                            if(data.childEntity[i].entityName.indexOf(this.filterText) != -1 && !data.childEntity[i].disabled) {
                                this.$refs.entityTree.setChecked(data.childEntity[i].id, checked, false)
                                data.childEntity[i].checked = checked
                            }
                        }
                    }
                }

            },
            iteratorTree(data, checked, idList) {
                if((idList.indexOf(data.id) != -1 || idList.indexOf(data.key) != -1) && !data.disabled) {
                    this.$refs.entityTree.setChecked(data.id, checked, false)
                    data.checked = checked
                }
                if (data.childEntity.length > 0) {
                    data.childEntity.forEach(child => this.iteratorTree(child, checked, idList));
                }
            },
            isSelectAll(data) {
                //判断当前node是否全部选中
                let flag = data.disabled || data.checked
                if (flag && data.childEntity.length > 0) {
                    flag = data.childEntity.every(item => { return item.disabled || item.checked })
                    if(flag) {
                        let flagArr = []
                        for(let i = 0 ; i < data.childEntity.length; i++ ){
                            if(data.childEntity[i].childEntity.length > 0 ){
                                flagArr[i] = data.childEntity[i].childEntity.every(item => { return item.disabled || item.checked })
                            }
                        }
                        flag = flagArr.every(item => item === true)
                    }
                }
                return flag
            },

            changeDrawer() {
              this.$refs.entityTree.setCheckedKeys(this.getEntityIds)
            },
            // 关闭重新查询表格
            handleClose(done) {
                done();
                this.filterText = ''
                this.bounceAdd()
            },
            bounceAdd: _.debounce(function() {
              this.$store.commit('common/setEntityIds', this.$refs.entityTree.getCheckedKeys())
              this.onAdd()
            }, 600),
            // 选中node
            activeNode(node) {
                if(!node.disabled) {
                    node.checked = !node.checked
                    this.$refs.entityTree.setChecked(node.id, node.checked, false)
                }
            },
            // checkbox点击事件
            handleCheckChange(node, checkInfo){
                node.checked = checkInfo.checkedKeys.indexOf(node.id) !== -1
            },
            // entity过滤
            filterNode(value, data) {
                if (!value) return true;
                let isShow = data.entityName.toLowerCase().indexOf(value.toLowerCase()) !== -1
                if(isShow) {
                    this.filterNodeList.push(data)
                }
                return isShow;
            }
        },
        computed: {
            ...mapGetters('common', {
                getSite: 'getSite',
                getEntityIds: 'getEntityIds',
            }),
            isSelectAllTag() {
                if (this.data && this.data.length) {
                    return this.isSelectAll(this.data[0])
                }
                return false
            }
        },
        watch: {
            filterText(val) {
                this.filterNodeList = []
                this.$refs.entityTree.filter(val);
            },
            entityData: {
                handler(val, oldVal) {
                    this.data = deepClone(val)
                },
                deep: true
            },
            isSelectAllTag: {
                handler(val, oldVal) {
                    this.$store.commit('common/setEntityIdsSelectAllTag', val)
                },
                deep: true
            }
        },
        props: {
            entityData: {
                type: Array,
                default: []
            },
            onAdd: {
                type: Function,
                default: () => {
                }
            }
        }
    };
</script>
<style scoped>
.drawer-wrapper ::v-deep .el-drawer .el-drawer__header{
    font-size: 18px;
    font-weight: bold;
}
</style>
<style>
  .entityTree {
    position: fixed;
    z-index: 10;
    top: 240px;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    font-size: 16px;
    text-align: center;
    background: #7213ea;
    border-radius: 4px 0 0 4px;
    cursor: pointer;
    transition: right .3s cubic-bezier(.9, 0, .3, .7);
    pointer-events: auto;
    color: #ffff;
  }
  .entity-list-tree-node {
      width: 100%;
      display: flex;
      justify-content: space-between;
      font-size: 12PX;
  }
  .entity-list-tree-node .extra-area {
      margin-right: 5px;
      color: #409eff;
      align-self: center;
  }
  .treeWithEntity .isActive {
    color: #409eff;
  }
  .wl-container .el-dialog__wrapper .el-drawer .el-drawer__body .el-input{
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
  }
  .wl-container .el-dialog__wrapper .el-drawer .el-drawer__body .el-input__inner{
    width: 95%;
  }
  .wl-matter-log-container .el-dialog__wrapper .el-drawer .el-drawer__body .el-input{
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
  }
  .wl-matter-log-container .el-dialog__wrapper .el-drawer .el-drawer__body .el-input__inner{
    width: 95%;
  }
  .el-tree>.el-tree-node{
    min-width:100%;
    display: inline-block;
  }
</style>
